<template lang="pug">
  .gift-widget__wr
    .gift-widget
      SvgIcon(name="gift" width="28" height="27" class="gift-widget__ico")
      SvgIcon(name="arrow-left" width="7" height="12" class="gift-widget__arrow")
    .gift-widget__popup
      //.gift-widget__popup-left
        .gift-widget__popup-left-border.gift-widget__popup-left-border--top
        .gift-widget__popup-left-border.gift-widget__popup-left-border--right
        .gift-widget__popup-left-border.gift-widget__popup-left-border--bottom
        .gift-widget__popup-left-border.gift-widget__popup-left-border--left
        .gift-widget__popup-left-corner.gift-widget__popup-left-corner--tl
        .gift-widget__popup-left-corner.gift-widget__popup-left-corner--tr
        .gift-widget__popup-left-corner.gift-widget__popup-left-corner--bl
        .gift-widget__popup-left-corner.gift-widget__popup-left-corner--br
        img.gift-widget__img(src="/img/content/gift-img.png")
      .gift-widget__popup-right
        .gift-widget__popup-right-gift1
        .gift-widget__popup-right-gift2
        .gift-widget__popup-right-gift3
        .gift-widget__popup-right-corner
        .gift-widget__close-wr
          SvgIcon(name="close" width="18" height="18" class="gift-widget__close")
        //.gift-widget__title Акция
        //.gift-widget__text При заказе доставки на сумму #[br] #[strong от 1500 ₽] пицца "Пепперони" в подарок
        .gift-widget__title Внимание!
        .gift-widget__text Доставка работает #[strong "на вынос"]
        router-link.gift-widget__btn(to="/menyu") В меню
</template>

<script>
//import '@/components/common/giftWidget/giftWidget.styl';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  components: {
    SvgIcon
  },

  name: "GiftWidget",

  mixins: [],

  props: {

  },

  created() {
    this.initScripts();
  },

  methods: {
    initScripts() {
      this.$nextTick(() => {
        $(document).on('click', '.gift-widget', function() {
          $('.gift-widget__popup').toggleClass('gift-widget__popup--show');
        });

        $(document).on('click', '.gift-widget__close-wr', function() {
          $('.gift-widget__popup').toggleClass('gift-widget__popup--show');
        });

        $(document).on('click', '.gift-widget__btn', function() {
          $('.gift-widget__popup').removeClass('gift-widget__popup--show');
        });

        setTimeout(() => {
          $('.gift-widget__popup').addClass('gift-widget__popup--show');
        }, 2500);
      });
    }
  }
}
</script>
